// Listen to Dom change, and add "Sendle" to OCTOLIZE SHIPPING COST CAL panel.
// 等待页面加载后执行
// 改成监听通用 class
const targetNode = document.querySelector('.shopify-app-block[id*="shipping_calculator"]');

if (targetNode) {
  const config = { childList: true, subtree: true };

  const observer = new MutationObserver(function(mutationsList) {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          $(node).find(".oct-shipping-rate__title").addBack(".oct-shipping-rate__title").each(function() {
            if ($(this).text().trim() === "Domestic" && !$(this).hasClass("sendle-added")) {
              $(this).text("Sendle Domestic").addClass("sendle-added");
            }
          });
        }
      });
    });
  });

  observer.observe(targetNode, config);
}




// ------------------------------
// Global Toast Function
// ------------------------------
// ------------------------------
// 全局 Toast（亮黄 + 👍 图标）
// ------------------------------
// 全局 Toast：任何地方都可以 showToast('任意文案')
window.showToast = function(message, duration = 2500) {
  const toast = document.createElement('div');

  toast.style.position = 'fixed';
  toast.style.left = '50%';
  toast.style.top = '20px';
  toast.style.transform = 'translateX(-50%) translateY(-20px)';
  toast.style.display = 'flex';
  toast.style.alignItems = 'center';
  toast.style.background = '#FFEB3B';
  toast.style.border = '1px solid #E0C300';
  toast.style.color = '#000';
  toast.style.padding = '10px 18px';
  toast.style.borderRadius = '10px';
  toast.style.boxShadow = '0 4px 14px rgba(0,0,0,0.25)';
  toast.style.fontSize = '16px';
  toast.style.fontWeight = '600';
  toast.style.opacity = '0';
  toast.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
  toast.style.zIndex = '999999';

  // ⭐ 响应式：手机端宽度 80vw
  if (window.innerWidth < 768) {
    toast.style.width = '90vw';     // 手机端宽度
    toast.style.boxSizing = 'border-box';
    toast.style.justifyContent = 'center';
  }

  // 左侧图标
  const iconBox = document.createElement('span');
  iconBox.textContent = '👍';
  iconBox.style.background = '#FFF8A6';
  iconBox.style.padding = '6px 10px';
  iconBox.style.marginRight = '10px';
  iconBox.style.borderRadius = '6px';
  iconBox.style.fontSize = '17px';

  const text = document.createElement('span');
  text.textContent = message;

  toast.appendChild(iconBox);
  toast.appendChild(text);
  document.body.appendChild(toast);

  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) translateY(0)';
  });

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(-50%) translateY(-20px)';
    setTimeout(() => toast.remove(), 300);
  }, duration);
};



// ------------------------------
// 2️⃣ 页面加载时，检测是否要自动弹 toast（通过 sessionStorage）
// ------------------------------
document.addEventListener('DOMContentLoaded', function () {
  try {
    const msg = window.sessionStorage.getItem('toastMessage');
    if (msg) {
      window.sessionStorage.removeItem('toastMessage');
      window.showToast(msg);
    }
  } catch (e) {
    console.error(e);
  }
});


 
// ------------------------------
//3️⃣ 通用加车函数：前端传 variantId + message，无需写逻辑e
window.addToCartAndReloadWithToast = function(variantId, message) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: Number(variantId), quantity: 1 })
  })
  .then(function () {
    try {
      // 这里不写死文案，完全用调用方传进来的 message
      window.sessionStorage.setItem('toastMessage', message);
    } catch (e) {
      console.error(e);
    }
    window.location.reload();
  })
  .catch(function (err) {
    console.error(err);
    // 失败兜底：直接跳到购物车，这样至少用户能看到结果
    window.location.href = '/cart';
  });
};




/* # To fix Brands .sub-menu overflow-x problem when screen is enlarged or on 1536px/1366px */
  (() => {
    const GAP = 1; // 菜单右边与视窗右边的间隙（px）

    for (const li of document.querySelectorAll('li[data-item-title="BRANDS"]')) {
      const menu = li.querySelector(':scope > .sub-menu');
      if (!menu) continue;

      const fit = () => {
        if (window.innerWidth < 990) return;           // 只在桌面端生效
        menu.style.marginLeft = '0px';                 // 先复位，再测量
        const { left, right } = menu.getBoundingClientRect();
        const viewRight = document.documentElement.clientWidth - GAP; // 不含滚动条
        const overflow = Math.min(right - viewRight, left - GAP);
        if (overflow > 0) menu.style.marginLeft = `${-overflow}px`;
      };

      li.addEventListener('mouseenter', fit);
      li.addEventListener('focusin', fit);             // 键盘 Tab 导航也适用
    }
  })();



/* ==========================================================================
   桌面端菜单：悬停打开，点击外部才关闭
   --------------------------------------------------------------------------
   原理：主题用 li:focus-within > .sub-menu 显示子菜单（app.css）。
         悬停时把焦点移到该项的链接上，菜单就会一直保持打开，
         直到用户点击别处（浏览器自动失焦），完全复用主题的显示样式。
   附加：子菜单超出屏幕右侧时，自动改为向左展开（.lei-flip）
   依赖：lei-custom.css 里的 .lei-hover-focus 和 .lei-flip 规则
   范围：仅桌面鼠标设备，手机/平板不受影响
   回滚：删除本段代码和对应 CSS 即可
   更新：2026-10 Leigh
   ========================================================================== */
(function () {
  // 只在桌面鼠标设备上启用
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  // 主题菜单容器，主题升级后如果失效，先检查这个选择器
  var nav = document.querySelector('.thb-full-menu');
  if (!nav) return;

  // 二级及以下的子菜单：如果超出屏幕右侧，就改为向左展开
  function flipIfOverflow(li) {
    if (!li.parentElement.classList.contains('sub-menu')) return; // 一级菜单向下展开，不处理
    var sub = li.querySelector(':scope > .sub-menu');
    if (!sub) return;
    li.classList.remove('lei-flip'); // 先按默认方向测量
    if (sub.getBoundingClientRect().right > document.documentElement.clientWidth) {
      li.classList.add('lei-flip');
    }
  }

  nav.addEventListener('mouseover', function (e) {
    var li = e.target.closest('li');
    if (!li || !nav.contains(li)) return;
    // 焦点已经在这一项里面（比如鼠标划过子菜单之间的空隙）就不动，避免误关下级菜单
    if (li.contains(document.activeElement)) return;
    var link = li.querySelector(':scope > a');
    if (!link) return;
    // 标记为"鼠标悬停触发的焦点"，CSS 据此隐藏焦点框；失焦时自动去掉标记
    link.classList.add('lei-hover-focus');
    link.addEventListener('blur', function () { link.classList.remove('lei-hover-focus'); }, { once: true });
    link.focus({ preventScroll: true });
    flipIfOverflow(li);
  });

  // 按 Esc → 失焦，菜单关闭
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.contains(document.activeElement)) document.activeElement.blur();
  });
})();